import React from "react";
import Tabs from "./Tabs";

export default class DashTabs extends React.Component {
  isTabActive = (path) => {
    return window.location.pathname === path;
  };

  getTabs = () => {
    return [
      {
        active: this.isTabActive("/dash"),
        display: "Overview",
        onClick: () => (window.location.href = "/dash"),
      },
      {
        active: this.isTabActive("/dash/door-statuses"),
        display: "Door Statuses",
        onClick: () => (window.location.href = "/dash/door-statuses"),
      },
      {
        active: this.isTabActive("/dash/script-responses"),
        display: "Script Responses",
        onClick: () => (window.location.href = "/dash/script-responses"),
      },
    ];
  };

  render() {
    return <Tabs tabs={this.getTabs()} />;
  }
}
